export default function anonymous(props
/*``*/) {
var out='<div class="'+(props.styles.icon)+'"> <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 14" preserveAspectRatio="xMidYMin slice" width="100%" style="padding-bottom: 140%; height: 1px; overflow: visible" > <!-- padding-bottom: 100% * height/width --> <path class="'+(props.themeStyles.playSvgFill)+'" d="M7 0h3v14H7V0zM0 0h3v14H0V0z"/> </svg></div>';return out;
}


//////////////////
// WEBPACK FOOTER
// ./default-modules/ui/controls/play/templates/pauseIcon.dot
// module id = 215
// module chunks = 0 1 2 3 4